import axios from 'axios';

class ForgotPasswordService {
  forgotPassword(email) {
    return axios.post('/api/auth/ForgotPassword', {
      Username: email,
      IsLabelApi: false,
    });
  }
}

export default new ForgotPasswordService();
